export default __webpack_public_path__ + "2bafbccc89387eae3dfbb02a20bbd5eb.png";